import React from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import DocumentCenter from '@/components/DocumentCenter';

const DocumentCenterPage = () => {
  const { patientId } = useParams();
  
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <DocumentCenter patientId={patientId} />
      </div>
    </div>
  );
};

export default DocumentCenterPage;
